/* globals gon */
// @flow
import React from 'react'
import LinkedServiceRow from './LinkedServiceRow'
import UnlinkedServiceRow from './UnlinkedServiceRow'

export default class LinkableService extends React.Component<{service: string}> {
  render () {
    const {service} = this.props
    const serviceCapitalized = service[0].toUpperCase() + service.substring(1)
    const {identities} = gon.user
    const identityId = identities && identities[service]() && identities[service]().get('id')

    return (
      <p className={`user-edit-services-${service}`}>
        {identityId
          ? <LinkedServiceRow
            serviceName={serviceCapitalized}
            identityId={identityId}
          />
          : <UnlinkedServiceRow serviceName={serviceCapitalized} service={service} />
        }
      </p>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/userEdit/ConnectedServices/LinkableService.js